module.exports = __webpack_public_path__ + "static/media/SY.70068a09.svg";